"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubAppSelfProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const SubAppSelfProviders = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: children });
};
exports.SubAppSelfProviders = SubAppSelfProviders;
//# sourceMappingURL=providers.js.map